// extracted by mini-css-extract-plugin
module.exports = {"awsui-select-dropdown":"ChannelTypeSmartE_awsui-select-dropdown__1kNjd"};